import axios from "axios";
import { APP_API_KEY, INSTANCE_URL } from "Constants";
import { showLoading, hideLoading } from "react-redux-loading-bar";

import { getHeaders } from "CommonUtils";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
} from "NetworkCall";

export var FETCH_WEBVIEW = "fetch_webview";
export var INSERT_WEBVIEW = "insert_webview";
export var LOAD_EDIT_WEBVIEW_DATA = "load_webview_edit_data";

export function fetchWebview(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/webview?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_WEBVIEW, payload: data });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function insertWebview(session, values, webview, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/webview/`;
  var response;

  var eventid = session.eventid;
  values = { ...values, eventid };
  var webviewJson = { resource: values };

  if (webview) {
    response = axios.patch(url, webviewJson, getHeaders(session));
  } else {
    response = axios.post(url, webviewJson, getHeaders(session));
  }

  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch(fetchWebview(session));
        var returnData = { error: 0, data: data };
        callback(returnData);
      })
      .catch((error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      });
  };
}
